// removed by extract-text-webpack-plugin
module.exports = {"globalFooter":"globalFooter___1FeW-","links":"links___1Se0F","copyright":"copyright___3ZDsQ"};


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/src/components/GlobalFooter/index.less
// module id = 440
// module chunks = 0